<template>
      <BreadCrumb PageTitle=" Liste des factures" />
    <ListeFacture/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeFacture from "@/components/Facture/ListeFacture.vue";

    export default defineComponent({
      name: "ListeFacturePage",
      components: {
        BreadCrumb ,
        ListeFacture,
      },
    });
  </script>